module.exports = __webpack_public_path__ + "img/img-b886b6.png";